import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Select, { MultiValue, StylesConfig, components } from 'react-select'
import { ToolTipUIForModal } from '../UI/ToolTipUIForModal'
import { toTitleCase } from '../../../compliance-meeting/core/_util'

interface Option {
  id: number
  value: string
  name: string
  role: string
}

interface UserSearchInputProps {
  options: Option[]
  placeholder?: string
  onChange: (selectedOptions: Option[]) => void
  tooltip: string
  label: string
}

const TagInputDropdown: React.FC<UserSearchInputProps> = ({
  options,
  placeholder,
  onChange,
  tooltip,
  label
}) => {
  const [selectedOptions, setSelectedOptions] = useState<Option[]>([])
  const navigate = useNavigate()

  const handleChange = (selected: MultiValue<Option>) => {
    const selectedArray = selected as Option[]
    setSelectedOptions(selectedArray)
    onChange(selectedArray)
  }

  // Custom Menu with button
  const CustomMenu = (props: any) => (
    <components.Menu {...props}>
      {props.children}
      <div
        style={{
          padding: '10px',
          margin: '10px',
          textAlign: 'center',
          cursor: 'pointer',
          fontWeight: 'bold',
          border: '1px solid #4776E6',
          color: 'white',
          backgroundColor: '#4776E6',
        }}
        onClick={() => navigate(`/setting/company-settings?tab=teams`)}
      >
        + Add more team
      </div>
    </components.Menu>
  )

  // Custom MultiValue component to display only the name in input field
  const CustomMultiValue = (props: any) => {
    return <components.MultiValue {...props}>{props.data.name}</components.MultiValue>
  }

  // Custom SingleValue component to display only the name in single select mode
  const CustomSingleValue = (props: any) => {
    return <components.SingleValue {...props}>{props.data.name}</components.SingleValue>
  }

  // Custom Styles
  const customStyles: StylesConfig<Option, true> = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#f0f0f0' : 'white',
      color: '#333',
      cursor: 'pointer',
      ':hover': {
        backgroundColor: '#e6e6e6',
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: 'white',
    }),
    control: (provided) => ({
      ...provided,
      backgroundColor: 'white',
    }),
  }

  return (
    <div>
      <label className='form-label font-size-13 text-dark text-capitalize ms-md-0 d-flex flex-md-row align-items-md-center'>
        {label}
        <ToolTipUIForModal tooltipText={tooltip} />
      </label>
      <Select
        options={options}
        placeholder={placeholder}
        onChange={handleChange}
        isMulti
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.id.toString()}
        formatOptionLabel={(option) => (
          <div className='d-flex justify-content-between'>
            {option.name}
            <span
              style={{
                fontWeight: 'bold',
                width: '109px',
                height: '24px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(71, 118, 230, 0.2)',
                color: '#4776E6',
                borderRadius: '4px',
              }}
            >
              {toTitleCase(option.role)}
            </span>
          </div>
        )}
        value={selectedOptions}
        components={{
          Menu: CustomMenu,
          MultiValue: CustomMultiValue,
          SingleValue: CustomSingleValue,
        }}
        styles={customStyles}
      />
    </div>
  )
}

export default TagInputDropdown
